export const requiresParsing = (str) => {
  if (typeof str !== 'string') {
    return false;
  }

  const matched = str.match(/[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}/);

  return Boolean(matched);
};
